'use client'

import { LgpdRightsCard } from '../LgpdRightsCard'
import { PostList } from '../PostList'

import { Page } from '@/shared/ui/Page'

export function HelpCenterListPage() {
  return (
    <Page variant="lightBlue">
      <div className="flex flex-col gap-4">
        <LgpdRightsCard />
        <PostList />
      </div>
    </Page>
  )
}
